import { BaseDialog } from "@/lib/Components/Dialog/BaseDialog";
import { GenericForm } from "@/lib/Components/Form/Forms/GenericForm";
import { useDialogState } from "@/lib/Components/Dialog/Hooks/useDialogState";
import { useGqlMutation } from "@/lib/GraphQLCodegen/fetcher";
import { createSupplierAdminContactMutation } from "@/app/Suppliers/GraphQL/supplierAdminContactMutations";
import { CreateSupplierAdminContactInput } from "@/gql/graphql";
import { DialogSubmitButton } from "@/lib/Components/Dialog/Components/DialogSubmitButton";
import { SupplierAdminContactForm } from "@/app/Suppliers/Forms/SupplierAdminContactForm";
import { toFormikValidationSchema } from "@/lib/Zod/zod-formik-adapter";
import { supplierAdminContactValidator } from "@/app/Suppliers/Validation/supplierAdminContactValidator";

export function SupplierAdminContactCreateDialog({
  supplierId,
}: {
  supplierId: string;
}) {
  const { close } = useDialogState();
  const { mutateAsync } = useGqlMutation(createSupplierAdminContactMutation);

  return (
    <BaseDialog title="Add Contact">
      <GenericForm<CreateSupplierAdminContactInput>
        initialValues={{
          supplier_id: supplierId,
          name: "",
          role: "",
          email: "",
          phone: "",
          description: "",
        }}
        validationSchema={toFormikValidationSchema(
          supplierAdminContactValidator,
        )}
        onSubmit={async (values) => {
          await mutateAsync({ input: values });
          await close();
        }}
      >
        <SupplierAdminContactForm />
        <DialogSubmitButton text="Add Contact" />
      </GenericForm>
    </BaseDialog>
  );
}
